import app from '@motionelements/core/src/store/modules/app.js';

export default {
  namespaced: true,
  state: () => app.state,
  getters: app.getters,
  actions: app.actions,
  mutations: app.mutations,
};
